"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.trackLog.status.neutral': 'Neutral',
    'whatsapp.trackLog.status.good': 'Good',
    'whatsapp.trackLog.status.warning': 'Warning',
    'whatsapp.trackLog.status.critical': 'Critical',
    'whatsapp.trackLog.type': 'Type:',
    'whatsapp.trackLog.goToSource': 'Go to source',
};
